import { render } from "./CIS-Alert-Secondary.vue?vue&type=template&id=6c93cabb&scoped=true"
import script from "./CIS-Alert-Secondary.vue?vue&type=script&lang=js"
export * from "./CIS-Alert-Secondary.vue?vue&type=script&lang=js"

import "./CIS-Alert-Secondary.vue?vue&type=style&index=0&id=6c93cabb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c93cabb"]])

export default __exports__